import { LOGGED_OUT_USERS_ONLY } from '$lib/services/auth/policies';
import { REG_PATH_EXCEPTION_HANDLER } from '$lib/services/auth/policy-exception-handler';

export const policy = LOGGED_OUT_USERS_ONLY;
export const policyExceptionHandler = REG_PATH_EXCEPTION_HANDLER;
